const palette = {
    mode: 'light',
    primary: {
        main: '#3FA8FF',
        light: '#75C1FF',
        dark: '#226AA8',
    },
    success: {
        main: '#2CE8BB',
    },
    warning: {
        main: '#FFBB54',
    },
    error: {
        main: '#FF6567',
    },
    white: {
        main: '#FFFFFF',
    },
    N05: {
        main: '#FFFFFF',
    },
    N10: {
        main: '#FFFFFF',
    },
    N20: {
        main: '#828D97',
    },
    N30: {
        main: '#828D97;',
    },
    N40: {
        main: '#828D97',
    },
    N50: {
        main: '#D1D9E0',
    },
    N60: {
        main: '#FFFFFF',
    },
    N70: {
        main: '#F6F8F9',
    },
    N80: {
        main: '#181E27',
    },
    N90: {
        main: '#171C25',
    },
    N95: {
        main: '#141921',
    },
    URed: {
        100: '#FFCDD2',
        300: '#E57373',
        600: '#E53935',
        900: '#B71C1C',
    },
    UPink: {
        100: '#F8BBD0',
        300: '#F06292',
        600: '#D81B60',
        900: '#880E4F',
    },
    UPurple: {
        100: '#D1C4E6',
        300: '#968DFE',
        600: '#5B39AC',
        900: '#2D208D',
    },
    UDeepPurple: {
        100: '#D1C4E6',
        300: '#968DFE',
        600: '#5B39AC',
        900: '#2D208D',
    },
    ULightBlue: {
        100: '#B3E4FB',
        300: '#4DC2F3',
        600: '#009BE0',
        900: '#005797',
    },
    UCyan: {
        100: '#B2EAF2',
        300: '#4ED0DF',
        600: '#00ABBF',
        900: '#016063',
    },
    UMint: {
        100: '#B3DEDB',
        300: '#4FB5AC',
        600: '#06887C',
        900: '#024D41',
    },
    UGreen: {
        100: '#C9E6CB',
        300: '#83C589',
        600: '#469E51',
        900: '#1E5D27',
    },
    ULime: {
        100: '#F1F4C7',
        300: '#DEE682',
        600: '#C2C94D',
        900: '#837629',
    },
    UYellow: {
        100: '#FFF9C8',
        300: '#FFF084',
        600: '#FFD853',
        900: '#F58031',
    },
    UOrange: {
        100: '#FFE0B7',
        300: '#FFB85D',
        600: '#FC8D2D',
        900: '#E5541F',
    },
    UDeepOrange: {
        100: '#FFCCBE',
        300: '#FF8C6B',
        600: '#F3552D',
        900: '#BF3A1B',
    },
    UBrown: {
        100: '#D7CCC8',
        300: '#A18880',
        600: '#6D4D43',
        900: '#3E2824',
    },
    UGrey: {
        100: '#F5F5F5',
        300: '#E0E0E0',
        600: '#757575',
        900: '#212120',
    },
    dropShadow: {
        main: '#0e1217',
    },
};

export { palette as default };
//# sourceMappingURL=palette-light.js.map
